import { Handle as RFHandle, HandleProps as RFHandleProps } from 'reactflow';

export type HandleProps = RFHandleProps;

export const Handle = (props: HandleProps) => {
  return <RFHandle {...props} style={{ display: 'none' }} onConnect={() => ({})} isConnectable={false} />;
};
